// Check moralisResponse.txt for the response from moralis
import { ethers } from "ethers";
import {
    AssetContractTypeEnum, ContractBase, ItemMap,
    NetworkEnum, TokenDataBase, TokenDataType } from "../commonInterfacesAndEnums";
import { fetchSkyMavisNFTs } from './skymavisNFTService';
import axios from 'axios';

export const MoralisChainNames: ItemMap<string> = {
    mainnet: "eth",
    // mumbai: "mumbai",
    matic: "polygon",
    bscMainnet: "bsc"
};


export const AlchemySupportedChains = [
  NetworkEnum.mainnet,
//   NetworkEnum.mumbai,
  NetworkEnum.matic,
]


const AlchemyBaseURL:any = {
  [NetworkEnum.mainnet]: "https://eth-mainnet.alchemyapi.io/nft/v2/zbEVEsP50JjeKSNyEgjrN7cl6FF-88zJ",
  [NetworkEnum.matic]: "https://polygon-mainnet.g.alchemy.com/nft/v2/Q2mUAUYFWL7I9RKf4Y4OJxCSqnmgCILJ",
//   [NetworkEnum.mumbai]: "https://polygon-mumbai.g.alchemy.com/nft/v2/IcFdYe3mleISObU-2kcTZ0Ljq6rQz_iZ",
  [NetworkEnum.bscMainnet]: "",
  [NetworkEnum.bora]: "",
};


async function getMoralisRequest(address:any, chain:any){
    const params = new URLSearchParams();
    const MORALIS_NFT_URL = (
        `https://deep-index.moralis.io/api/v2/${address}/nft`);
    //params.append('chain', MoralisChainNames[chain]);
    params.append('chain', MoralisChainNames[chain]);
    params.append('format', 'decimal');
    params.append('limit', '100');
    //(contractAddresses) && contractAddresses.forEach((contractAddress: string) => {
        //params.append('token_addresses', contractAddress);
    //});
    params.append('token_addresses', "0xf9e631014ce1759d9b76ce074d496c3da633ba12");
    params.append('normalizeMetadata', 'true');
    const header =  {
        params: params,
        headers: {
            'X-API-Key': '4fQWEHS3tYWFPKRh8wInkmroLBPnJFf1nHKiuM69alsirhBzKx2WnpLH7F4r2aDs',
            'accept': 'application/json'
        }
    }
    const response = await axios.get(MORALIS_NFT_URL, header);
    return response;
}

function getChainContractAddressMap(
    contracts: any[]){
    const chainContractAddressMap: any = {};
    contracts.forEach((contract: ContractBase) => {
        if (!(chainContractAddressMap[contract.chain] )) {
            chainContractAddressMap[contract.chain] = [contract.contractAddress]
        }
        else {
            chainContractAddressMap[contract.chain].push(
                contract.contractAddress);
        }
    });
    return chainContractAddressMap;
}


async function getNFTsFromMoralis(
    contracts: any[] = [], address:any) {
    let nfts:any[] = []
    for(let chain of Object.keys(MoralisChainNames)){
        let response = await getMoralisRequest(address, chain);
        const data: any = response.data;
        let tempData = processMoralisResponse(
            data, "62fd0e1b5f653536e9c657a8",
            chain, contracts);
        if(!tempData){continue;}
        nfts = nfts.concat(tempData);
    }
    return nfts;
}


async function getAlchemyResponse(address:any, chain:any){
    //const params = new URLSearchParams();
    let url = `${AlchemyBaseURL[chain]}/getNFTs?`;
    const params: any = {
        'owner': address,
        'withMetadata': true,
        'pageSize': 100
    };
    const response = await axios.get(url, {
        params: params,
        headers: {
            'accept': 'application/json'
        }
    });
    return response;
}



function convertAlchemyToMoralisResponse(
    alchemyResponse: any
): any {
    const moralisResponse: any = {
        result: alchemyResponse.ownedNfts.map((
            alchemyNFT:any) => {
                
                let image_url = alchemyNFT.media[0].raw;
                if(alchemyNFT.metadata.static_image_url){
                    image_url = alchemyNFT.metadata.static_image_url;
                }
                return {
                    token_id: alchemyNFT.id.tokenId,
                    contract_type: alchemyNFT.contractMetadata.tokenType, // You can set a default value or leave it empty
                    token_address: alchemyNFT.contract.address,
                    blockchain: "", // You can set a default value or leave it empty,
                    amount: alchemyNFT.balance,
                    normalized_metadata: {
                        name: alchemyNFT?.metadata?.name?alchemyNFT?.metadata?.name:alchemyNFT.contractMetadata.name,
                        description: alchemyNFT.metadata.description || alchemyNFT.metadata.name,
                        //image_url: alchemyNFT.metadata.static_image_url?alchemyNFT.metadata.static_image_url:alchemyNFT.metadata.image_url,
                        image_url: image_url,
                        external_link: alchemyNFT.external_link,
                        animation_url: alchemyNFT.animation_url,
                    attributes: alchemyNFT.attributes,
                    },
                }}),
  };
  return moralisResponse;
}

async function getNFTsFromAlchemy(
    contracts: any[] = [], address:any) {
    let nfts:any[] = []
    for(let chain of AlchemySupportedChains){
        let response = await getAlchemyResponse(
            address, chain);
        const data: any = convertAlchemyToMoralisResponse(response.data);
        //const data: any = response.data;
        let tempData = processMoralisResponse(
            data, "62fd0e1b5f653536e9c657a8",
            chain, contracts);
        if(!tempData){continue;}
        nfts = nfts.concat(tempData);
    }
    return nfts;
}



function getTokenData(
    token:any, companyId:any, contract:any,
    fakeContractId?:any){
    const tokenData: TokenDataBase = {        
        type: token.contract_type as TokenDataType,
        creatorId: companyId,
        name: token.normalized_metadata.name?token.normalized_metadata.name:token.name,
        description: token.normalized_metadata.description || "",
        externalUri: token.normalized_metadata.external_link || "",
        imageUri: token.normalized_metadata.image_url,
        videoUri: token.normalized_metadata.animation_url || "",
        supply: 1,
        decimals: 1, // @todo Are you sure????????
        attributes: token.normalized_metadata.attributes,
        externalMetadataUri: token.token_uri,
        assetContractId: contract ? contract.id : fakeContractId,          // Fill this before creating the tokenData
        tokenId: token.token_id,        // Generate a token id as soon as this data is recieved
        lazyForm: null,
        encodedFormBytes: null,
    } as TokenDataBase;
    return tokenData;
}

function getContractData(
    contract:any, chain:any, token:any,
    companyId:any, fakeContractId:any){
    const contractOut: ContractBase = {
        _id: contract ? contract.id : fakeContractId,
        id: contract ? contract.id : fakeContractId,
        chain: chain as NetworkEnum,
        name: "",
        symbol: token.symbol,
        type: token.contract_type as AssetContractTypeEnum,
        confirmed: true,
        contractAddress: ethers.utils.getAddress(token.token_address),
        creatorId: companyId,
        isExternal: true,
        isGlobal: false,
    } as ContractBase;
    return contractOut;
}

function processMoralisResponse(
    data:any, companyId:any,
    chain:any, contracts:any){
    let tokens:any = []
    const addressToContractMap: any = {};
    contracts.forEach((contract: ContractBase) => {
        addressToContractMap[contract.contractAddress] = contract;
    });
    const contractsResp: ContractBase[] = [];
    const contractOutMap: any = {};
    if(data.result && data.result.length < 1){
        return
    }
    for(let token of data.result){
        const contract = addressToContractMap[token.token_address] || contractOutMap[token.token_address];
        let fakeContractId;
        if (!contract) {
            fakeContractId = Date.now().toString(36) + Math.random().toString(36).substring(2);
        }
        let tokenData = getTokenData(
            token, companyId, contract, fakeContractId);
        let contractOut = getContractData(
            contract, chain, token, companyId, fakeContractId);
        contractOutMap[token.token_address] = contractOut;
        contractsResp.push(contractOut);
        const resp: any = {
            token: tokenData,
            ...tokenData,
            imageUri: tokenData.imageUri,
            ...contractOut,
            quantity: ethers.BigNumber.from( token.amount ).toString(),
            exchange: [],
            tokenId: tokenData.tokenId,
        }
        window.dispatchEvent(new CustomEvent(
            'tokenAdded', {detail: {
                'nft': resp}}));
        tokens.push(resp);
    }
    return tokens;
}

export async function addInformationToNFTTokenList(
    backendResponse: any,
    address: any
) {
    let contracts = backendResponse.nfts.contracts;
    if (contracts.length === 0) {
        return;
    }

    // Fetch NFTs from different sources
    const [alchemyNFTs, skyMavisNFTs] = await Promise.all([
        getNFTsFromAlchemy(contracts, address),
        fetchSkyMavisNFTs(address)
    ]);

    // Combine NFTs from different sources
    const combinedNFTs = [
        ...(alchemyNFTs || []),
        ...(skyMavisNFTs || [])
    ];
    // window.dispatchEvent(new CustomEvent('allTokenAdded', {
    //     detail: {
    //         'tokenList': combinedNFTs
    //     }
    // }));
    return combinedNFTs;
}
